var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9.98239 7.92572C9.66523 7.6593 9.19214 7.70044 8.92572 8.01761C8.6593 8.33477 8.70044 8.80786 9.01761 9.07428L11.5176 11.1743C11.7965 11.4086 12.2035 11.4086 12.4824 11.1743L14.9824 9.07428C15.2996 8.80786 15.3407 8.33477 15.0743 8.01761C14.8079 7.70044 14.3348 7.6593 14.0176 7.92572L12.75 8.99051V5.5C12.75 5.08579 12.4142 4.75 12 4.75C11.5858 4.75 11.25 5.08579 11.25 5.5V8.99051L9.98239 7.92572ZM8.9806 15.259C8.68179 15.5458 8.6721 16.0206 8.95896 16.3194C9.24582 16.6182 9.72059 16.6279 10.0194 16.341L11.25 15.1597V18.5C11.25 18.9142 11.5858 19.25 12 19.25C12.4142 19.25 12.75 18.9142 12.75 18.5V15.0095L14.0176 16.0743C14.3348 16.3407 14.8079 16.2996 15.0743 15.9824C15.3407 15.6652 15.2996 15.1921 14.9824 14.9257L12.4824 12.8257C12.189 12.5793 11.757 12.5936 11.4806 12.859L8.9806 15.259Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMinimize);
export default __webpack_public_path__ + "static/media/arrow-minimize.6fa18a282edfcf112d8bc64929702f97.svg";
export { ForwardRef as ReactComponent };